interface MovieCardSkeletonProps {
  count?: number;
}

export default function MovieCardSkeleton({ count = 8 }: MovieCardSkeletonProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-5">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="rounded-lg bg-background-100 border border-background-300/60 overflow-hidden"
        >
          <div className="w-full aspect-[2/3] skeleton-bar animate-shimmer" />
          <div className="p-3 space-y-2">
            <div className="h-3.5 w-3/4 rounded bg-background-200 skeleton-bar animate-shimmer" />
            <div className="h-3 w-1/2 rounded bg-background-200 skeleton-bar animate-shimmer" />
          </div>
        </div>
      ))}
    </div>
  );
}